import { render, staticRenderFns } from "./gift-pack-item.vue?vue&type=template&id=3ee80226&scoped=true"
import script from "./gift-pack-item.vue?vue&type=script&lang=js"
export * from "./gift-pack-item.vue?vue&type=script&lang=js"
import style0 from "./gift-pack-item.vue?vue&type=style&index=0&id=3ee80226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee80226",
  null
  
)

export default component.exports